import React, { Component } from 'react';
import { isCompositeComponentWithType } from 'react-dom/test-utils';

class Time extends Component {
    constructor(props){
        super(props)
        this.state = {d: new Date()}
    }
    componentDidMount() { 
        this.timeID = setInterval(
            () => this.Change(),
            1000
        )
    }
    componentWillUnmount(){ 
        clearInterval(this.timeID)
    }    
    Change = () => { 
                this.setState({
                    d : new Date(),
                })
            }      
    render() {
        var date = new Date();
        var year = date.getFullYear();
        var month = ("0" + (1 + date.getMonth())).slice(-2);
        var day = ("0" + date.getDate()).slice(-2);
        var hour = date.getHours();
        var min  = ("0" + (1 + date.getMinutes())).slice(-2);
        var sec  = ("0" + (1 + date.getSeconds())).slice(-2);
        var stime="";
       
        const today= year + "-" + month + "-" + day;
        const curtime= hour + " : " + min + " : " +sec;
        const token = JSON.parse(localStorage.getItem("userInfo"));
        if(typeof token !==null){stime=token[0].time2}        
        return (
            <div className="time-container d-flex align-items-center">
                <div className="d-flex align-items-center">
                    <span className="icon-wrap">
                        <svg className="icon time-icon" xmlns="http://www.w3.org/2000/svg" viewBox="4 4 16 16">
                            <g transform="translate(-270 -146)">
                                <path className="fill" d="M282,150a8,8,0,1,0,8,8A8.009,8.009,0,0,0,282,150Zm0,14.222A6.222,6.222,0,1,1,288.222,158,6.229,6.229,0,0,1,282,164.222Z" fill="#fff"/>
                                <path className="fill" d="M286,157.111h-3.973l-2.165-1.6a.889.889,0,0,0-1.058,1.429l2.4,1.777a.889.889,0,0,0,.53.175H286a.889.889,0,1,0,0-1.778Z" fill="#fff"/>
                            </g>
                        </svg>
                    </span>
                    <div className="date d-flex flex-column">
                        <span>현재 날짜 : {today}</span>
                        <span>현재 시간 : {curtime}</span>
                    </div>
                </div>
                <div className="d-flex flex-column exam-time position-relative">
                    <span>시작 시간 :{stime}</span>
                </div>
            </div>
        );
    }
}

export default Time;
